import Ahoy from 'ahoy.js'

// This bundle is embedded on external sites (www.interline.io, www.transit.land)
// that send analytics to app.interline.io. The Rails app itself tracks visits
// server-side via after_action :track_ahoy_visit and does not use this script.
//
// AHOY_URL can be overridden at build time for local dev
// (e.g. AHOY_URL=https://your-tunnel.ngrok-free.app).
//
// cookies: false disables ahoy.js's ahoy_visit and ahoy_visitor cookies (GDPR).
Ahoy.configure({
  urlPrefix: AHOY_URL,
  visitsUrl: '/ahoy/visits',
  eventsUrl: '/ahoy/events',
  withCredentials: true,
  cookies: false,
})

window.interline = {
  // Start tracking. Call once per page load.
  //
  // Accepts either:
  //   - a number/string  → treated as IWA user_id
  //   - an object        → passed as visitParams; use any identifier the server accepts:
  //                         { user_id, auth0_uid, email, api_token, amberflo_customer_id }
  //                         (`amberflo_customer_id` is accepted for legacy compatibility)
  //   - null/undefined   → anonymous visitor (no user linked)
  start: function (identifiers) {
    if (identifiers != null) {
      var params = (typeof identifiers === 'object') ? identifiers : { user_id: identifiers }
      Ahoy.configure({ visitParams: params })
    }
    Ahoy.trackView()
  },
  track: function (name, props) {
    Ahoy.track(name, props || {})
  },
}
